import React, {
  // forwardRef,
  useState,
} from "react";
import AvatarProfile from "./avatarProfile";
// import Avatar from "react-avatar-edit";
import {
  // CheckRounded, Close,
  PhotoCameraOutlined,
} from "@mui/icons-material";
// import { Translate } from "../features/i18n/translate";
import {
  // AppBar,
  Button,
  // Dialog,
  // IconButton,
  // Slide,
  // Toolbar,
  // Typography,
} from "@mui/material";
import { addImageUser } from "../features/users/action";
import { useDispatch, useSelector } from "react-redux";
import "./uploadProfile.css";
// import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
// import { useRef } from "react";

const UploadProfile = ({ img, id }) => {
  const [base64Profile, setBase64Profile] = useState(img);
  // const [profileName, setProfileName] = useState("");
  // const [openDialog, setOpenDialog] = useState(false);
  // const [imgSrc, setImgSrc] = useState(img);
  // const [completedCrop, setCompletedCrop] = useState();

  // const [crop, setCrop] = useState({
  //   unit: "%", // Can be 'px' or '%'
  //   x: 25,
  //   y: 25,
  //   width: 50,
  //   height: 50,
  // });

  // const imgRef = useRef(null);

  // const { language } = useSelector((state) => state.i18n);

  const dispatch = useDispatch();

  // const handleOpen = () => setOpenDialog(true);
  // const handleClose = () => setOpenDialog(false);

  // const onCrop = async (base64String) => {
  //   const base64Data = base64String.split(",").pop();
  //   const type = base64String.substring(5, base64String.indexOf(";"));

  //   fetch(base64String)
  //     .then((res) => res.blob())
  //     .then((blob) => {
  //       const args = {
  //         base64Profile: base64String,
  //         profile: blob,
  //         fileName: "aa.png",
  //         id,
  //       };
  //       dispatch(addImageUser(args));

  //       // انجام عملیات مورد نیاز با Blob
  //       console.log(blob);
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //     });
  // };

  const onChangeProfile = (e) => {
    // if (e.target.files && e.target.files.length > 0) {
    //   setCrop(undefined); // Makes crop preview update between images.
    //   const reader = new FileReader();
    //   reader.readAsDataURL(e.target.files[0]);
    //   reader.addEventListener("load", () =>
    //     setImgSrc(reader.result?.toString() || "")
    //   );
    // }

    // setOpenDialog(true);

    const file = e.target.files[0];
    let reader = new FileReader();
    // // reader.addEventListener("load", () =>
    // //   // setBase64Profile(reader.result?.toString() || "")
    // //   console.log("dsdsd", reader.result?.toString())
    // // );
    reader.readAsDataURL(file);

    // reader.addEventListener("load", () =>
    //   setImgSrc(reader.result?.toString() || "")
    // );

    reader.onload = (event) => {
      setBase64Profile(event.target.result);
      const args = {
        base64Profile: event.target.result,
        profile: file,
        fileName: file.name,
        id,
      };
      dispatch(addImageUser(args));
    };
  };

  // const Transition = forwardRef(function Transition(props, ref) {
  //   return <Slide direction="up" ref={ref} {...props} />;
  // });

  // const onImageLoad = (e) => {
  //   console.log(e);
  //   const { naturalWidth: width, naturalHeight: height } = e.currentTarget;
  //   const crop = centerCrop(
  //     makeAspectCrop(
  //       {
  //         // You don't need to pass a complete crop into
  //         // makeAspectCrop or centerCrop.
  //         unit: "%",
  //         width: 90,
  //       },
  //       16 / 9,
  //       width,
  //       height
  //     ),
  //     width,
  //     height
  //   );

  //   setCrop(crop);
  // };

  return (
    <>
      <Button
        className="upload-image-container"
        component="label"
        // onClick={handleOpen}
      >
        <AvatarProfile img={base64Profile} isEdit />

        <div className="camera-icon">
          <PhotoCameraOutlined fontSize="small" color="white" />
        </div>
        <input
          type="file"
          accept="image/png, image/gif, image/jpeg"
          style={{ display: "none" }}
          onChange={onChangeProfile}
        />
      </Button>
      {/* <Dialog fullScreen open={openDialog} onClose={handleClose}>
        <AppBar
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: 2,
            paddingRight: 2,
            flexDirection: "row",
            minHeight: 56,
          }}
        > */}
      {/* <Close onClick={handleClose} /> */}
      {/* <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div"> */}
      {/* {Translate("editPhoto", language)} */}
      {/* </Typography> */}
      {/* <CheckRounded /> */}
      {/* <Button autoFocus color="inherit" onClick={handleClose}>
            save
          </Button> */}
      {/* </AppBar> */}
      {/* {!!imgSrc && (
          <ReactCrop
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={(c) => setCompletedCrop(c)}
            aspect={16 / 9}
            minWidth={400}
            minHeight={100}
            // circularCrop
          >
            <img ref={imgRef} alt="Crop me" src={imgSrc} onLoad={onImageLoad} />
          </ReactCrop>
        )} */}

      {/* <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "grey",
            width: "100%",
            position: "relative",
          }}
        >
          <Avatar
            // width={window.innerWidth}
            // height={300}
            onCrop={onCrop}
            cropRadius={window.innerWidth / 2}
            // onBeforeFileLoad={this.onBeforeFileLoad}
            onClose={handleClose}
            src={base64Profile}
          />
        </div> */}
      {/* </Dialog> */}
    </>
  );
};

export default UploadProfile;
